export default "__VITE_ASSET__CciAsG61__"